import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, ROUTER_PATHS, TABLE_CONSTANTS_COLUMS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useGetPlanCorporativo } from "@/shared/actions/erp/planes";
// import { useGetCapacidadCorporativo } from "@/shared/actions/erp/planes/planes_corporativos.actions";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { useTableColumnsCapacidadCorporativo } from "@/shared/hooks/useTableColumnsCapacidadCorporativo";
import { PlanesCorporativos } from "@/shared/interfaces";
// import { CapacidadCorporativa } from "@/shared/interfaces/erp/planes_corporativos/planes_corporativos.interface";
import { useNavigate } from "react-router-dom";

export default function PlanCoporativoPage() {

  const navigate = useNavigate();


  ///* table
  const {
    pagination,
    searchTerm,
    setPagination,
  } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  ///* fetch data
  const {
    data: planCorporativoRes,
    isLoading,
    isRefetching,
  } = useGetPlanCorporativo({
    page: pageIndex + 1,
    page_size: pageSize,
    nombre: searchTerm,
    ...filterObject,
    filterByState: false,
    plan_personalizado: false,
  });

  const { columnBase } = useTableColumnsCapacidadCorporativo({})

  return (
    <SingleTableBoxScene
      title="Planes Corporativos"
      urlRedirect={`${ROUTER_PATHS.ventasCorporativas.planCorporativoCrearNav}`}
      enableRedirect={hasPermission(PermissionsEnum.api_add_plancoorporativo)}
    >
      <GeneralTable<PlanesCorporativos>
        columns={columnBase}
        data={planCorporativoRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // filters - llega al back
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableSorting={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={planCorporativoRes?.data?.count}
        // // actions ========
        enableColumnActions={true}//{hasPermission(PermissionsEnum.api_change_plancoorporativo)}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.ACTIONCOLUMN_WIDTH}
        positionActionsColumn="first"
        // crud
        canEdit={true}//{hasPermission(PermissionsEnum.api_change_plancoorporativo)}
        onEdit={(value) => {
          navigate(`${ROUTER_PATHS.ventasCorporativas.planCorporativoEditarNav}/${value.id_plan_coorporativo}`)
        }}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );

}